export default "__VITE_ASSET__gXcHfdm8__"